<lo-grandmaster #gm (finishedLoading)="addToGrandmaster($event, data)" *ngIf="data !== undefined" class="noPrint" id="grandmaster" />
<div id="printSection" class="print">
  <div *ngFor="let path of imgPaths">
    <img alt="print" [src]="path">
  </div>
  <ng-container>
    <ng-container *ngIf= "currentTab === 'Provider'; else facilityPrint">
      <app-print-search-results [aggregateRoot]="providerPrintResults.providers!" [printState]="printState" type="practitioner"></app-print-search-results>
    </ng-container>
    <ng-template #facilityPrint>
      <app-print-search-results [aggregateRoot]="facilityPrintResults.facilities!" [printState]="printState" type="facility"></app-print-search-results>
    </ng-template>
  </ng-container>
</div>
